/* Daily game's "How to Play" rules content. The dialog shell
   (native <dialog>, backdrop-click close, first-visit auto-open) is
   shared with the Match prototype via <HowToPlayDialog>. Examples
   render real <Cell> instances with the same marks and pivot
   styling the live game uses, and the reveal demo buttons reuse the
   `.hint__button` style the live Reveal Hint / Reveal Spaces
   controls render with — so the rule reference always tracks the
   actual visuals. */

import { Cell } from "./Cell";
import { HowToPlayDialog } from "./HowToPlayDialog";

export function HowToPlay() {
  return (
    <HowToPlayDialog
      classPrefix="howtoplay"
      storageKey="palindragon-first-visited"
      firstVisitOpenDelayMs={2000}
      triggerLabel="How to Play"
    >
      <h2 id="howtoplay-title" class="howto-dialog__title">
        How to Play PalinDragon™
      </h2>
      <p class="howto-dialog__lede">
        Solve the daily palindrome — a sentence that reads the same
        forward and backward.
      </p>

      <h3 class="howto-dialog__heading">Mirrors fill together</h3>
      <p>Type once; the symmetric slot fills automatically.</p>
      <div class="howtoplay__row">
        <Cell letter="A" />
        <Cell letter={null} />
        <Cell letter={null} pivot />
        <Cell letter={null} />
        <Cell letter="A" />
      </div>

      <h3 class="howto-dialog__heading">Feedback</h3>
      <ul class="howtoplay__legend">
        <li>
          <Cell letter="A" mark="green" />
          <span>Right letter, right spot.</span>
        </li>
        <li>
          <Cell letter="N" mark="yellow" />
          <span>Right letter, wrong spot.</span>
        </li>
        <li>
          <Cell letter="A" mark="red" />
          <span>Right letter — but every spot it goes is already correct in this guess.</span>
        </li>
        <li>
          <Cell letter="X" mark="gray" />
          <span>Letter not in the solution.</span>
        </li>
      </ul>

      <h3 class="howto-dialog__heading">The Pivot</h3>
      <p>The symmetry center — always one or two letters.</p>
      <ul class="howtoplay__pivot-list">
        <li>
          <span class="howtoplay__pivot-label">Odd-length</span>
          <div class="howtoplay__row">
            <Cell letter={null} pivot />
          </div>
        </li>
        <li>
          <span class="howtoplay__pivot-label">Even-length</span>
          <div class="howtoplay__row">
            <Cell letter={null} pivot />
            <Cell letter={null} pivot />
          </div>
        </li>
      </ul>

      <h3 class="howto-dialog__heading">Buy a Reveal</h3>
      <p>
        Stuck? You can buy one of two reveals. Each costs guesses
        but stays on for the rest of the puzzle.
      </p>
      <div class="howtoplay__hint-demo">
        <button
          type="button"
          class="hint__button"
          tabIndex={-1}
          aria-hidden="true"
        >
          Reveal Hint{" "}
          <span class="hint__cost">(costs 2 guesses)</span>
        </button>
      </div>
      <p>An oblique clue at the meaning — never the letters.</p>
      <div class="howtoplay__hint-demo">
        <button
          type="button"
          class="hint__button"
          tabIndex={-1}
          aria-hidden="true"
        >
          Reveal Spaces{" "}
          <span class="hint__cost">(costs 3 guesses)</span>
        </button>
      </div>
      <p>
        The word breaks and punctuation appear in place, exposing
        the puzzle’s structure.
      </p>
      <p>
        Solve without buying either reveal and you earn the 🐲 Hard
        Mode 🐲 badge of honor.
      </p>

      <br/>
      <p><strong>A new puzzle drops at 00:00 UTC every day, worldwide.</strong></p>
    </HowToPlayDialog>
  );
}
